import styled from '@emotion/styled';
import { TableCell, tableCellClasses, TableRow, Typography, Divider, TableContainer, Paper, Table, TableHead, TableBody,
     Button } from '@mui/material';
import { Box } from '@mui/system';
import { format } from 'date-fns';
import { observer } from 'mobx-react-lite';
import { useEffectOnce } from 'usehooks-ts';
import GenerateReportHeading from '../../../app/common/reportsHeading/GenerateReportHeading';
import { withNavbar } from '../../../app/layout/HOC';
import SkeltonAnimation from '../../../app/layout/SkeltonAnimation';
import { TempPartnerSignup } from '../../../app/models/partners';
import { useStore } from '../../../app/stores/store';
import { koReportingContainerStyles } from '../../basicUser/koreporting/reports/koReportingContainerStyles';
import AdminPartnerTempDeleteModal from './AdminPartnerTempDeleteModal';
import AdminPartnerTempModal from './AdminPartnerTempModal';
import AdminPartnerTempResendModal from './AdminPartnerTempResendModal';

const StyledTableCell = styled(TableCell)(() => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#fcfcfc',
        fontSize: 16,
        fontWeight: 300,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        fontWeight: 300,
        fontStrethed: 'expanded',
    },
}));
const StyledTableRow = styled(TableRow)(() => ({
    '&:nth-of-type(odd)': {
        backgroundColor: '#DAE5F1',
    },
    '&:nth-of-type(even)': {
        backgroundColor: '#fcfcfc',
    },
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const AdminPartnerTempSignUp = () => {

    const { partnerStore, modalStore } = useStore();
    const { loadAdminPartnerTempKobhoveds, adminPartnerTempKbhoveds, adminPartnerTempLoading } = partnerStore;

    const { openModal } = modalStore;

    useEffectOnce(() => {
        loadAdminPartnerTempKobhoveds();
    })

    return (
        <Box component='div' sx={{mt:20}} >
            {adminPartnerTempKbhoveds.length < 1 && !adminPartnerTempLoading &&
                <Typography variant='h4' textAlign='center' sx={{ mt: 5, color: '#072B02' }} >No records found</Typography>}
            {adminPartnerTempLoading && <SkeltonAnimation iteration={10} />}
            {!adminPartnerTempLoading && adminPartnerTempKbhoveds.length > 0 &&
                <>
                <GenerateReportHeading heading='Pending Sign up' />
                    <Divider sx={{ height: 20 }} />
                    <TableContainer component={Paper} sx={koReportingContainerStyles.table}>
                        <Table aria-label="Partner table">
                            <TableHead key={'tableKey'}>
                                <TableRow sx={{ backgroundColor: '#fcfcfc' }}>
                                    <StyledTableCell>Date</StyledTableCell>
                                    <StyledTableCell>Name</StyledTableCell>
                                    <StyledTableCell>Email</StyledTableCell>
                                    <StyledTableCell>Roles</StyledTableCell>
                                    <StyledTableCell>Detail</StyledTableCell>
                                    <StyledTableCell>Resend Email</StyledTableCell>
                                    <StyledTableCell>Delete</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {adminPartnerTempKbhoveds.map((t1a: TempPartnerSignup, index) =>
                                    <StyledTableRow
                                        key={t1a.id}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <StyledTableCell>
                                            {format(new Date(t1a.createdDate), 'dd MMM yyyy')}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {t1a.username}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {t1a.emailId}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {t1a.roles}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <Button onClick={() => openModal(<AdminPartnerTempModal partnerData={t1a}
                                            />)} >Detail</Button>
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <Button  onClick={() => openModal(<AdminPartnerTempResendModal partnerData={t1a}
                                            />)}>Resend</Button>
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <Button onClick={() => openModal(<AdminPartnerTempDeleteModal partnerData={t1a}
                                            />)}>Delete</Button>
                                        </StyledTableCell>
                                    </StyledTableRow>
                                )
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Box>
                    </Box>
                </>
            }
        </Box>
    )
}
const AdminPartnerTempSignUpPage = withNavbar(observer(AdminPartnerTempSignUp));
export default AdminPartnerTempSignUpPage;